import { StatusBadge } from "./Status";

const BADGE = { health: "bg-[#0B281E] text-[#FAF8F5]", life: "bg-[#C88A35] text-[#071510]", general: "bg-[#F4F1EA] text-[#0B281E] border border-[#0B281E]/15" };
const LABEL = { health: "Health", life: "Life", general: "Other" };
const fmt = (s) => new Date(s).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });

export const LeadList = ({ items, onOpen }) => {
  if (!items.length) return <p className="py-20 text-center text-[#52635B]" data-testid="lead-empty">No quote requests match these filters yet.</p>;
  return (
    <div className="divide-y divide-[#0B281E]/10" data-testid="lead-list">
      {items.map((l) => (
        <button key={l.id} onClick={() => onOpen(l)} data-testid={`lead-row-${l.id}`}
          className="w-full text-left grid grid-cols-[1fr_auto] md:grid-cols-[110px_80px_1.2fr_1.4fr_1.6fr_100px] gap-x-4 gap-y-1 items-center px-4 py-4 hover:bg-[#F4F1EA] transition-colors">
          <span className="order-3 md:order-none text-xs text-[#52635B]">{fmt(l.created_at)}</span>
          <span className="order-2 md:order-none justify-self-end md:justify-self-start"><span className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${BADGE[l.type]}`}>{LABEL[l.type]}</span></span>
          <span className="order-1 md:order-none font-semibold text-[#0B281E] truncate">{l.name}</span>
          <span className="order-4 md:order-none col-span-2 md:col-span-1 text-sm text-[#52635B] truncate">{l.phone} · {l.email}</span>
          <span className="order-5 md:order-none col-span-2 md:col-span-1 text-sm text-[#1A2621] truncate">{l.location && `${l.location} · `}{l.details}</span>
          <span className="order-6 md:order-none col-span-2 md:col-span-1 md:justify-self-end"><StatusBadge status={l.status} /></span>
        </button>
      ))}
    </div>
  );
};
